@if (type === 'confirm') {
  <div class="flex flex-column flex-center-center gap-16" style="padding: 18px 18px 5px 18px;">
    <div *ngIf="topIcon" class="mini-card" [style.background-color]="topIcon.backgroundColor">
      <app-icon [size]="'3xl'" [name]="topIcon.name" [color]="topIcon.color"></app-icon>
    </div>

    <p class="fs-md text-primary">{{title}}</p>
    <p class="fs-md text-center">{{content}}</p>

    <div class="flex-center-center gap-24" style="padding-top: 15px">
      <button (click)="onCancel()" nz-button nzType="default" class="highlight-btn">{{cancelText}}</button>
      <button (click)="onConfirm()" nz-button nzType="primary">
        <app-icon *ngIf="loading" [name]="'loader-circle'" [size]="'base'"></app-icon>
        {{confirmText}}
      </button>
    </div>
  </div>
} @else if (type === 'delete') {
  <div class="flex flex-column gap-16">
    <p class="fs-md text-semibold">{{title}}</p>
    <div class="flex flex-column gap-4">
      <span class="fs-xs">{{content}}</span>
      <p *ngIf="showFixedMsg" class="fs-xs text-semibold" style="color: #64748B">Esta acción no se puede deshacer.</p>
    </div>
    <div class="flex-center-end gap-24">
      <button (click)="onCancel()" nz-button nzType="default">{{cancelText}}</button>
      <button (click)="onConfirm()" nz-button nzType="primary" nzDanger>
        <app-icon *ngIf="loading" [name]="'loader-circle'" [size]="'base'" color="#fff"></app-icon>
        {{confirmText}}
      </button>
    </div>
  </div>
}
